import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { AttendContactLeaveEarlyJson } from '@/types/domain/attendContact/entities/attendContactLeaveEarlyEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import LeaveEarlyInfo from '@/domain/attendContact/component/LeaveEarlyInfo';

/** プロパティ */
export type ConfirmInput = {
  /** データ */
  data: AttendContactLeaveEarlyJson | undefined,
  /** 送信 */
  onSend: (input: AttendContactLeaveEarlyJson | undefined) => void,
}

const Confirm: React.FC<ConfirmInput> = ({ data, onSend }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => onSend(undefined)}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="早退連絡" />
    <DialogContent>
      <p>内容を確認し問題なければ、「送信」ボタンを押してください。</p>
      {data && <LeaveEarlyInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => onSend(data)} color="primary">
        送信
      </Button>
      <Button variant="contained" onClick={() => onSend(undefined)} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default Confirm;
